import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import ExpenseDataGrid from '../ExpenseDataGrid';
import ExpenseList from '../ExpenseList';
import type { Filter } from '#/common/components/DataGrid';

interface ExpensesProps {
  omitColumns?: string[];
  permanentFilters?: Filter[];
  hideNewAction?: boolean;
}

const Expenses: React.FC<ExpensesProps> = ({ omitColumns, permanentFilters, hideNewAction }) => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <ExpenseDataGrid
          omitColumns={omitColumns}
          permanentFilters={permanentFilters}
          hideNewAction={hideNewAction}
        />
      </If>
      <If condition={!isDesktop}>
        <ExpenseList permanentFilters={permanentFilters} />
      </If>
    </>
  );
};

export default React.memo(Expenses);
